
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    classObj() {
      return {
        // justify-content
        'justify-start': this.blok.justify_content === 'start',
        'justify-end': this.blok.justify_content === 'end',
        'justify-between': this.blok.justify_content === 'between',
        'justify-evenly': this.blok.justify_content === 'evenly',
        'justify-around': this.blok.justify_content === 'around',
        // align-items
        'items-center': this.blok.align_items === 'center',
        'items-start': this.blok.align_items === 'start',
        'items-end': this.blok.align_items === 'end',
        'items-stretch': this.blok.align_items === 'stretch',
        'items-baseline': this.blok.align_items === 'baseline',
        'flex-wrap':
          this.blok.responsive_wrap === 'xs' || this.blok.flex_wrap === true,
        'flex-wrap sm:flex-nowrap': this.blok.responsive_wrap === 'sm',
        'flex-wrap md:flex-nowrap': this.blok.responsive_wrap === 'md',
        'flex-wrap lg:flex-wrap': this.blok.responsive_wrap === 'lg',
      }
    },
  },
}
